import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import ShareBox from './shareBox';

import errorBoundary from '@ifeng/errorBoundary';
import { rel } from '../../../../utils/rel';
class Header extends React.PureComponent {
    /**
     * 渲染网页布局
     */
    render() {
        const { docData } = this.props;
        const { columnData } = docData;
        const { title, logo, url } = columnData;
        // 列表信息

        return (
            <div className={styles.LivingTitleBox}>
                <div className={styles.LivingTitleCon}>
                    <div className={styles.fl}>
                        <a href={url} target="_blank" rel={rel} className={styles.logo}>
                            <img src={logo} alt={title} title={title} />
                        </a>
                    </div>
                    <div className={styles.fr}>
                        <ShareBox docData={docData} />
                    </div>
                </div>
            </div>
        );
    }
}

/**
 * 定义组件属性类型
 * */
Header.propTypes = { docData: PropTypes.object };

/**
 * 定义组件默认属性
 * */
Header.defaultProps = {};

export { Header };
export default errorBoundary(Header);
